// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gPgA","toggle":"styles_toggle__1ranV","preview":"styles_preview__3FyYM"};